import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {FILE_UPLOAD_CELL_SLICE} from './file-upload-cell-constants';

export interface IFileUploadCellState {
  isCellFileUploading: boolean;
}

const initialState: IFileUploadCellState = {
    isCellFileUploading: false,
};

const fileUploadCellSlice = createSlice({
    name: FILE_UPLOAD_CELL_SLICE,
    initialState,
    reducers: {
        setIsCellFileUploading: (state, action: PayloadAction<boolean>) => {
            state.isCellFileUploading = action.payload;
        },
    },
});

export const selectIsCellFileUploading = (state: TAppState) => state[FILE_UPLOAD_CELL_SLICE]?.isCellFileUploading;

export const {
    reducer: fileUploadCellReducer,
    actions: fileUploadCellActions,
} = fileUploadCellSlice;
